import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import greenButtonVue from "@/components/common/green-button.vue";
import readMore from "@/components/common/read-more.vue";

Vue.component('green-button', greenButtonVue)
Vue.component('read-more', readMore)

Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
